import { chromelessLayout } from '@atlassian/jira-chromeless-layout/src/index.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { softwareCapacityCustomEmbedRoute } from '@atlassian/jira-router-routes-software-capacity-routes/src/softwareCapacityCustomEmbedRoute.tsx';
import { CapacityEmbedSkeleton } from '@atlassian/jira-skeletons/src/ui/capacity/CapacitySkeleton.tsx';
import { jiraSpaResources } from '@atlassian/jira-router-resources-spa-page-container/src/index.tsx';
import { capacityRouteEntry } from './common/capacityRouteEntry.tsx';

export const softwareCapacityCustomEmbedRouteEntry = createEntry(
	softwareCapacityCustomEmbedRoute,
	() => ({
		group: 'software',
		skeleton: CapacityEmbedSkeleton,
		component: CapacityEmbedSkeleton,

		entryPoint() {
			return capacityRouteEntry;
		},

		layout: chromelessLayout,
		resources: [...jiraSpaResources()],
		ufoName: 'next-gen-capacity-embed',

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-software-capacity-entries/src/softwareCapacityCustomEmbedRouteEntry.tsx',
				whichExportToUse: 'softwareCapacityCustomEmbedRouteEntry',
			},

			enabled: true,
		},
	}),
);
